import "./CompanyShareholdersTabComponent.scss";
import template from "./CompanyShareholdersTabComponent.html";
import {IComponentOptions} from "angular";

export const CompanyShareholders = "tfCompanyShareholdersTab";

export function companyShareholders(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<"
        },
        controllerAs: "ctrl",
        controller: CompanyDirectorsTabComponentController
    };
}

export class CompanyDirectorsTabComponentController {

    /** @ngInject */
    public constructor() {

    }
}
